// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__tEQlN","title-wrapper":"Hero_title-wrapper__M0Zz_","title":"Hero_title__IwV6n","img-wrapper":"Hero_img-wrapper__6C8BH"};